import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';
import getTypographyConfig from '../../../Style-guide/typography-config';

const OrganizerHeaderWrapper = styled.header`
  ${({ $language }) => {
    const typography = getTypographyConfig($language);
    const dropdownLeft = { en: '-20px', hy: '-45px' }[$language] || '-20px';

    return `
      .dropdown-menu {
        left: ${dropdownLeft};

        .menu-item {
          button,
          a {
            font-size: ${16 * typography.scale}px;
            font-weight: ${typography.fontWeight};
            font-family: 'Segoe UI';

            display: block;
            background: none;
            border: none;
            margin: 0;
            padding: 4px 8px;
          }
        }
      }
    `;
  }}

  width: 100%;
  padding: 20px;
  box-sizing: border-box;

  .language-flag-icon-btn {
    display: inline-flex;
    transition: transform 0.4s ease-in-out;
    margin-right: 12px;

    svg {
      width: 30px;
      height: 30px;
      margin: 0;
    }

    &.spin {
      transform: rotate(360deg);
    }
  }

  .dropdown-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 60px;
    margin-bottom: 20px;
  }

  .account-icon {
    border: 3px solid ${mainColors.main_color};
    border-radius: 15px;
    transition: box-shadow 0.1s;
    width: 64px;
    height: 58px;
    fill: ${mainColors.main_color};

    &:hover {
      box-shadow: 0px 0px 10px 0px ${mainColors.text_color};
    }
  }

  @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
    .account-icon {
      width: 50px;
      height: 50px;
    }

    .dropdown-menu-container {
      left: -30px;
    }
  }
`;

export default OrganizerHeaderWrapper;
